import { render } from "./ModalContentSelector.vue?vue&type=template&id=f4cde2fc&lang=true"
import script from "./ModalContentSelector.vue?vue&type=script&lang=js"
export * from "./ModalContentSelector.vue?vue&type=script&lang=js"
script.render = render

export default script